// Copyright (c) 2017 Deere & Company

import DivisionSummary, {getDefaultState as getDivisionSummaryDefaultState} from './division-summary';
import t from 'tcomb';

const AuditStatus = t.struct({
    divisionSummary: DivisionSummary,
    isDcsm: t.Boolean,
    userId: t.String
}, {
    name: 'AuditStatus',
    strict: true
});

export const getDefaultState = () => new AuditStatus({
    divisionSummary: getDivisionSummaryDefaultState(),
    isDcsm: false,
    userId: ''
});

export default AuditStatus;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/audit-status.js